import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import Avatar from '@material-ui/core/Avatar';

import NoAvatarImage from 'public/images/no-avatar.svg';
import styles from 'styles/components/SimpleCard.module.scss';

const avatarFullSize = { width: '100%', height: '100%' };
const size = { width: 35, height: 35 };

const SimpleCard = ({ profile }) => (
  <Link href={`/m/${profile.username}?d`} passHref>
    <div className={styles.card}>
      <div className={styles.shadow} />

      <div style={{ display: 'flex' }}>
        <div className={styles.imgContainer}>
          <Image src={profile.avatar_url} layout="fill" alt="Avatar" unoptimized />
        </div>

        <Avatar src={profile.avatar_url} alt="Profile" style={size} className={styles.avatar}>
          <NoAvatarImage style={avatarFullSize} />
        </Avatar>

        <h3>{profile.display_name}</h3>
      </div>
    </div>
  </Link>
);

export default SimpleCard;
